export default __webpack_public_path__ + "static/media/74.0d54d157.png";